import { convertToCalendarEvent } from 'owa-publishedcalendar-eventdetails';
import { getSurfaceStore } from '../store/publishedCalendarSurfaceStore';
import { mutator } from 'satcheljs';
import { default as setCalendarItems } from '../actions/setCalendarItems';

/**
 * Mutator that sets calendar items in the Published Calendar surface store
 */
mutator(setCalendarItems, actionMessage => {
    const { events, replaceAll } = actionMessage;
    const store = getSurfaceStore();

    if (replaceAll) {
        store.calendarItems = [];
    }

    let calendarEvents = events.map(convertToCalendarEvent);
    store.calendarItems.push(...calendarEvents);
});
